import React from "react"
import classnames from "classnames"

const Htags = ({ children, className }) => {
  return <h1 className={classnames("htags", className)}>{children}</h1>
}

const H2 = ({ children, className }) => {
  return <h2 className={classnames("htags--h2", className)}>{children}</h2>
}

const H3 = ({ children, className }) => {
  return <h3 className={classnames("htags--h3", className)}>{children}</h3>
}

Htags.h2 = H2
Htags.h3 = H3

export default Htags
